import { render, staticRenderFns } from "./SetNewForgotPasswordForm.vue?vue&type=template&id=cc9a8ca2&scoped=true&"
import script from "./SetNewForgotPasswordForm.vue?vue&type=script&lang=js&"
export * from "./SetNewForgotPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./SetNewForgotPasswordForm.vue?vue&type=style&index=0&id=cc9a8ca2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9a8ca2",
  null
  
)

export default component.exports